import { useMutationState } from '~/hooks/reactQuery/useMutationState';
import { useLocaleKeys } from '~/i18n';
import { useStoreActions } from '~/store/store-context';
export const useCreateAdHoc = ()=>{
    const { api } = useStoreActions();
    const { t: globalBillModalTexts } = useLocaleKeys('components.globalBillModal');
    const { mutate, isPending } = useMutationState({
        mutationFn: (contactId)=>api.relationship.createAdHoc(contactId),
        toasts: {
            errorMessage: globalBillModalTexts.createAdHocError(),
            errorTestId: 'global-bill-modal-create-adhoc-error-toast'
        }
    });
    return {
        createAdHoc: mutate,
        isCreatingAdHoc: isPending
    };
};
